import { useCallback } from 'react';
import { useSafeFocusEffect, useSafeNavigation } from '@sg/garnish';

export const useCustomScreenTitle = (
  title: string,
  shouldUsePostfix = true,
) => {
  const navigation = useSafeNavigation();

  useSafeFocusEffect(
    useCallback(() => {
      if (!title) return;

      const formattedTitle = shouldUsePostfix ? `${title} | sweetgreen` : title;

      navigation?.setOptions({ customDocumentTitle: formattedTitle });
    }, [navigation, title, shouldUsePostfix]),
  );
};
